<div class="dialog__height">
    <div mat-dialog-title>
        <div class="dialog__header no_border-bottom">
            <span class="font-size-m text-capitalize">
                {{ 'fieldsConfiguration.title' | translate }}
            </span>
            <button type="button" id="btn_closeFieldsConfigurationDialog" mat-icon-button mat-dialog-close
                [disabled]="saveLoading">
                <icon name="close"></icon>
            </button>
        </div>
    </div>

    <mat-dialog-content>
        <div class="bg-sys-surface border-radius-rounded p-4">
            <div *ngIf="initLoading" class="d-flex justify-content-center align-items-center"
                style="min-height: calc(100vh - 17rem);">
                <mat-spinner diameter="40"></mat-spinner>
            </div>

            <div *ngIf="!initLoading">
                <div class="row align-items-center mb-2">
                    <div class="col">
                        <div class="search-control p-0 search-control--border-radius-m">
                            <mat-form-field class="field-space-none">
                                <input matInput type="search" id="textbox_fieldsSearch"
                                    placeholder="{{ 'fieldsConfiguration.search' | translate }}"
                                    [(ngModel)]="searchQuery" name="fieldsSearch"
                                    (ngModelChange)="onSearchQueryChange()" autocomplete="off" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-auto">
                        <button id="btn_resetFieldsConfiguration" type="button" mat-button color="warn"
                            (click)="onReset()" [disabled]="saveLoading">
                            <icon name="undo" class="button__icon"></icon>
                            {{ 'buttons.reset' | translate }}
                        </button>
                    </div>
                </div>

                <div class="bg-surface-1 border-radius-m">
                    <div cdkDropList (cdkDropListDropped)="onDrop($event)" [cdkDropListDisabled]="saveLoading"
                        class="fields-list">
                        <div *ngFor="let field of fieldsConfiguration; let i = index; let last = last"
                            class="bg-sys-surface border-radius-m"
                            [ngClass]="{'mb-2': !last, 'highlighted': matchedIndices.includes(i)}" cdkDrag
                            [cdkDragDisabled]="field.isPositionLocked" #fieldRow>
                            <div class="fields-list__item">
                                <div class="d-flex align-items-center gap-2">
                                    <icon *ngIf="!field.isPositionLocked" name="drag_indicator" class="cursor-grab"></icon>
                                    <icon *ngIf="field.isPositionLocked" name="lock" class="text-muted"
                                        [matTooltip]="('fieldsConfiguration.positionLocked' | translate)"
                                        matTooltipPosition="above"></icon>
                                    <span>{{ labelKey(field) | translate }}</span>
                                </div>
                                <button type="button" id="btn_changeFieldVisibility_{{field.field}}" mat-icon-button
                                    [disabled]="!field.canChangeVisibility || saveLoading"
                                    [matTooltip]="('fieldsConfiguration.cannotBeHidden' | translate)"
                                    [matTooltipDisabled]="field.canChangeVisibility" matTooltipPosition="above"
                                    (click)="toggleFieldVisibility(field)">
                                    <icon [name]="field.isVisible ? 'visibility' : 'visibility_off'"></icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog__footer justify-content-end no_border-top">
        <button id="btn_discardFieldsConfiguration" type="button" mat-stroked-button color="primary" mat-dialog-close
            [disabled]="saveLoading">
            {{'buttons.discard' | translate }}
        </button>
        <button id="btn_submitFieldsConfiguration" type="button" mat-flat-button color="primary" (click)="onSubmit()"
            [disabled]="initLoading || saveLoading" [class.spinner]="saveLoading">
            {{'buttons.save' | translate }}
        </button>
    </mat-dialog-actions>
</div>